import { useState } from "react";
import { apply } from "../../../../core/utils";
import { displayError, displayMessage } from "../../../../core/utils/modals";
import usePathNavigate from "../../../../hooks/use-path-navigate";
import { useRouting } from "../../../../hooks/with-routing";
import { enviarCodigo as apiEnviarCodigo, obtenerIniciales as apiObtenerIniciales, restablecerClave as apiRestablecerClave } from "../api/common.api";
import RestablecerClaveForm from "../components/restablecer-clave-form";

export enum RestablecerClaveSteps {
	Inicio,
	Captura,
	Registro
}

const useRestablecerClave = () => {
	const segmento = useRouting.use.currentSegment();
	const [cargandoDatos, setCargandoDatos] = useState(false);
	const [iniciales, setIniciales] = useState("");
	const [currentStep, setCurrentStep] = useState(RestablecerClaveSteps.Inicio);
	const navigate = usePathNavigate();

	const reiniciar = () => {
		setIniciales("");
		setCurrentStep(RestablecerClaveSteps.Inicio);
	};

	const obtenerIniciales = (usuario: string) => {
		setCargandoDatos(true);

		apiObtenerIniciales(segmento, usuario)
			.then(setIniciales)
			.then(apply(setCurrentStep, RestablecerClaveSteps.Captura))
			.catch(displayError)
			.finally(apply(setCargandoDatos, false));
	};

	const enviarCodigo = (usuario: string, telefono: string) => {
		setCargandoDatos(true);

		apiEnviarCodigo(segmento, usuario, telefono)
			.then(apply(setCurrentStep, RestablecerClaveSteps.Registro))
			.catch(displayError)
			.finally(apply(setCargandoDatos, false));
	};

	const restablecerClave = (usuario: string, clave: string, codigoOtp: string) => {
		setCargandoDatos(true);

		apiRestablecerClave(segmento, usuario, clave, codigoOtp)
			.then(apply(displayMessage, "La contraseña fue restablecida con éxito"))
			.then(apply(navigate, "/:segmento/login"))
			.catch(displayError)
			.finally(apply(setCargandoDatos, false));
	};

	const reenviarCodigo = (usuario: string, telefono: string) => {
		setCargandoDatos(true);

		apiEnviarCodigo(segmento, usuario, telefono)
			.then(apply(displayMessage, "Hemos enviado tu nuevo token al teléfono que registraste"))
			.catch(displayError)
			.finally(apply(setCargandoDatos, false));
	};

	return {
		currentStep,
		cargandoDatos,
		iniciales,
		obtenerIniciales,
		enviarCodigo,
		reenviarCodigo,
		restablecerClave,
		reiniciar
	};
};

const RestablecerClavePage = () => {
	const {
		currentStep,
		cargandoDatos,
		iniciales,
		obtenerIniciales,
		enviarCodigo,
		reenviarCodigo,
		restablecerClave,
		reiniciar
	} = useRestablecerClave();

	return (
		<div className="vh-100 d-flex justify-content-center align-items-center">
			<div className="container">
				<div className="row d-flex justify-content-center">
					<div className="col-12 col-md-8 col-lg-5">
						<div className="card card-login">
							<div className="card-body p-5">
								<RestablecerClaveForm
									cargandoDatos={cargandoDatos}
									step={currentStep}
									iniciales={iniciales}
									obtenerIniciales={obtenerIniciales}
									enviarCodigo={enviarCodigo}
									reenviarCodigo={reenviarCodigo}
									restablecerClave={restablecerClave}
									reiniciar={reiniciar}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default RestablecerClavePage;